module.exports = __webpack_public_path__ + "static/src/content/silks/pierata.de2d3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/pierata.png
// module id = 3flw
// module chunks = 0